<script>
    import Preloader from './Preloader.svelte';
</script>

<div class="unauthorized-message-container">
    <div class="text-center">
        <img src="/assets/img/icons/info.svg" alt="info" />
        <p class="unauthorized-title">
            No pudimos completar tu solicitud en este momento
        </p>
        <p class="unauthorized-description">
            Nuestro equipo de soporte se pondrá en contacto contigo en breve
        </p>
    </div>
</div>
